// services/aboutService.js
import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// Remove getAuthHeaders() since the interceptor handles authentication automatically

export const getAboutData = async () => {
  try {
    // Use api.get() instead of axios.get()
    const res = await api.get(`${API_URL}/about`);
    return res.data;
  } catch (error) {
    console.error('Error fetching about data:', {
      status: error.response?.status || 'N/A',
      error: error.response?.data?.error || 'Unknown error',
      message: error.response?.data?.message || error.message,
      exceptionType: error.response?.data?.exceptionType || 'N/A',
      path: error.response?.data?.path || 'N/A',
      timestamp: error.response?.data?.timestamp || 'N/A'
    });
    // User-friendly error message for the caller
    throw new Error(
      error.response?.data?.message || 
      'Failed to fetch about data. Please try again or contact support.'
    );
  }
};

export const updateAboutData = async (data) => {
  // Use api.put() instead of axios.put()
  const res = await api.put(`${API_URL}/about`, data);
  return res.data;
};